// extracted by mini-css-extract-plugin
export default {"pupsprizedcard":"DogCardPupsPrized_pupsprizedcard__ClM-w","numberoverlay":"DogCardPupsPrized_numberoverlay__uRiNe"};